var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcShipCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EFF6F2",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 11)",
    fill: "#2F665C",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.822 4.431A1 1 0 0 0 19 4H5.333L4.179 1.23A1.994 1.994 0 0 0 2.333 0H0v2h2.333l4.744 11.385A1 1 0 0 0 8 14h8c.417 0 .79-.259.937-.648l3-8a1 1 0 0 0-.115-.921zM15.307 12h-6.64l-2.5-6h11.39l-2.25 6z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 16.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 16.5,
    r: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShipCart);
export default __webpack_public_path__ + "static/media/ic-ship-cart.a5d7ad5a12be6ca11fc9e3462c533471.svg";
export { ForwardRef as ReactComponent };